import React from 'react'
function Nav() {
    return (
        <div>
        <nav className = "head">
            <div>
                <h1>Extension Uninstall Feedback</h1>
            </div>
        </nav>
        
        </div>
    )
}

export default Nav
